/**
 *  CDB客人资料查询
 */
import { axios } from '@/utils/request'

const subPath = '/cdb/customer'

export default {
  query,
  detail,
  add,
  update,
  'delete': remove,
  addCustomerTourRecord,
  deleteCustomerTourRecord,
  queryTrash,
  recovery,
  mergeJoinToOtherCustomer
}

// 分页查询
function query (parameter) {
  return axios({
    url: `${subPath}/query`,
    method: 'get',
    params: { ...parameter, 'page.curPage': parameter.curPage, 'page.pageSize': parameter.pageSize }
  })
}

// 详情
function detail (id) {
  return axios({
    url: `${subPath}/${id}`,
    method: 'get'
  })
}

// 添加
function add (parameter) {
  return axios({
    url: `${subPath}`,
    method: 'post',
    data: parameter
  })
}

// 修改
function update (id, parameter) {
  return axios({
    url: `${subPath}/${id}`,
    method: 'put',
    data: parameter
  })
}

// 删除
function remove (parameter) {
  return axios({
    url: `${subPath}`,
    method: 'delete',
    params: parameter
  })
}

//  客人参团记录添加
function addCustomerTourRecord (id, parameter) {
  return axios({
    url: `${subPath}/${id}/addCustomerTourRecord`,
    method: 'put',
    data: parameter
  })
}

//  客人参团记录删除
function deleteCustomerTourRecord (id, parameter) {
  return axios({
    url: `${subPath}/${id}/deleteCustomerTourRecord`,
    method: 'delete',
    params: parameter
  })
}

// 分页查询 回收站
function queryTrash (parameter) {
  return axios({
    url: `${subPath}/trash/query`,
    method: 'get',
    params: { ...parameter, 'page.curPage': parameter.curPage, 'page.pageSize': parameter.pageSize }
  })
}

// 修改
function recovery (id) {
  return axios({
    url: `${subPath}/trash/recovery/${id}`,
    method: 'put'
  })
}

// 将参团记录合并到其他客人资料
function mergeJoinToOtherCustomer (customerId, targetCustomerCode) {
  return axios({
    url: `${subPath}/${customerId}/mergeJoinToOtherCustomer/${targetCustomerCode}`,
    method: 'put'
  })
}
